var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"block mx-auto text-blue-900 underline capitalize mb-10 mt-10",on:{"click":function($event){return _vm.$router.push({ name: 'HelpAndSupport' })}}},[_vm._v(" "+_vm._s(_vm.$t("message.need-help"))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }